import React from 'react';

const Branch = props => {
  return (
    <div>
      test
    </div>
  );
};

export default Branch;